const filterNullAndUndefinedFieldsFromObject = (obj) => {
  const result = Object.keys(obj).reduce((acc, propName) => {
    if (obj[propName] !== undefined && obj[propName] !== null) {
      return {...acc, [propName]: obj[propName]}
    }
    return acc
  }, {})

  return result
}

export default filterNullAndUndefinedFieldsFromObject
